module.exports = __webpack_public_path__ + "static/img/product18-1.d1b770e4.png";